import { Route, withTranslatedMeta } from 'i18n/utils'
import { withRouteParams } from 'shared/hoc'

import { backgroundSelector } from '../selectors'
import LocationView from './LocationView'
import LocationsView from './LocationsView'
import '../styles/on-street.scss'

const OnStreetView = ({ background }) => (
    <div id="on-street" className="on-street">
        <Image className="background" image={background} background />
        <Route exact path="/on-street" component={LocationsView} />
        <Route path="/on-street/:slug" render={props => <LocationView {...props} key={props.match.params.slug} />} />
    </div>
)

export default compose(
    withTranslatedMeta('onstreet.locations.title'),
    withRouteParams,
    connect(
        createStructuredSelector({
            background: backgroundSelector,
        })
    )
)(OnStreetView)
